class HeaderLocalization extends HTMLElement {
  constructor() {
    super();
    this.forms = this.querySelectorAll('form');
    this.init();
  }

  init() {
    this.forms.forEach(form => {
      const button = form.querySelector('button');
      const list = form.querySelector('ul');
      const input = form.querySelector('input[name="locale_code"], input[name="country_code"]');

      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const expanded = button.getAttribute('aria-expanded') === 'true';
        this.closeAll(); 
        if (!expanded) {
          this.openDropdown(button, list);
        }
      });

      list.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          const value = item.getAttribute('data-value');
          if (input) {
            input.value = value;
            form.submit();
          }
        });
      });

      form.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.closeAll();
      });
    });

    document.body.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    });
  }

  openDropdown(button, list) {
    button.setAttribute('aria-expanded', 'true');
    list.removeAttribute('hidden');
    const disclosure = button.closest('.loc-disclosure');
    if (disclosure) disclosure.setAttribute('open', '');
  }

  closeAll() {
    this.querySelectorAll('button').forEach(btn => {
      btn.setAttribute('aria-expanded', 'false');
      const disclosure = btn.closest('.loc-disclosure');
      if (disclosure) disclosure.removeAttribute('open');
    });
    this.querySelectorAll('ul').forEach(list => list.setAttribute('hidden', true));
  }
}

customElements.define('header-localization', HeaderLocalization);